function sortBoolean(valueA: boolean, valueB: boolean) {
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
}

export default sortBoolean;
